<template>
  <v-app style="background-color: #FF5A00; width:100%; height:1928px;">

  <v-container  >
    <v-row justify="center" align="center" class="mb-12">
      <v-col cols="5">
        <v-img  src="https://tunaydisenio.s3.sa-east-1.amazonaws.com/win/winlong.jpeg" />
      </v-col>
    </v-row>
    <v-row justify="center" align="center" class="mt-12">
      <v-col cols="2">
        <img  style="z-index: 1;" src="https://tunaydisenio.s3.sa-east-1.amazonaws.com/win/flechabajo.png" width="70%"    />
      </v-col>
    </v-row>
    <v-row justify="center" align="center">
      <v-col cols="10" xl="10"  >

      <img id="ruleta" src="https://tunaydisenio.s3.sa-east-1.amazonaws.com/win/RuletaWin.png"  width="100%" @click="girarRuleta"   />

      </v-col>

    </v-row>
  </v-container></v-app>
</template>

<script>

export default {
  name: 'Ruleta',
  components:{

  },
  data(){
    return{
        data: [
            { id: '', type: 'allin', color: '#1b87e6', text: 'Tequila QP', ikon: '' },
        ],
        bis: false,
        angulo: 0,
        indice: 0,
        options: {
            angleOffset: -90
        },
    }
  },
  methods:{
    girarRuleta() {
      let imagen = document.getElementById('ruleta');
      let duracion = Math.random() * 3000 + 4000; // Duración aleatoria entre 2 y 4 segundos
      if (duracion < 4000) {
        duracion = 4000; // Establecer una duración mínima de 4 segundos
      }
      console.log("duracion")
      console.log(duracion)
      let velocidad = duracion / 4; // Velocidad constante en función de la duración total
      let anguloInicial = Math.random() * 360; // Ángulo de inicio aleatorio
      let anguloFinal = anguloInicial + Math.random() * 360; // Ángulo final aleatorio
      console.log(velocidad)

      imagen.style.pointerEvents = 'none'; // Desactivar interacción con la imagen
      imagen.style.transition = `transform ${velocidad}ms ease-out`;
      imagen.style.transform = `rotate(${anguloFinal}deg)`;
      console.log(anguloInicial)
      setTimeout(() => {
        imagen.style.pointerEvents = 'auto'; // Reactivar interacción con la imagen
        imagen.style.transition = 'none';
        imagen.style.transform = `rotate(0deg)`; // Mantener la imagen en la posición final
      }, duracion);
    }
},
  mounted () {
  },
}
</script>
